// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateSignature_container__3O8kY"};